// 对axios进行封装
import axios from 'axios'
// import QS from 'qs' //将对象序列化成URL
import config from './config'
import { Notify, Dialog } from 'vant';
import router from '../router'



const statusError = (status, other) => {
    switch (status) {
        case '7':
			localStorage.removeItem("token")
			localStorage.removeItem("position")
			localStorage.removeItem("code")
			localStorage.removeItem("position_error")
			router.push({ name: 'guodu' })
			Notify({ type: 'danger', message: '请先登录' })
            setTimeout(() => {
				router.push({ name: 'user' })
                isPast = false  
            }, 100)
            break;
        case 404:
			Notify({ type: 'danger', message: '请求不存在' });
            break;
        case 500:
			Notify({ type: 'danger', message: '服务器出错' });
            break;
        case 502:
			Notify({ type: 'danger', message: '请检查网络' });
            break
        case 503:
			Notify({ type: 'danger', message: '服务器不可用' });
            break;
        default:
			Notify({ type: 'danger', message:other });
    }
}

const status = (status, other) => {
    switch (status) {
        case 1003:
			Notify({ type: 'danger', message: other });
            break;
    }
}
//对axios进行初始化
//对axios进行初始化
let instance
	instance=axios.create({ timeout: 600000, headers: {}, baseURL: config.apiHost+'/kk'}) 
	// instance=axios.create({ timeout: 600000, headers: {}, baseURL: "http://2940l062d1.qicp.vip/kk"}) 
// 添加请求拦截器
instance.defaults.headers['Content-Type'] = 'application/json';
instance.interceptors.request.use(function (config) {
     // 高德api不支持自定义请求头所以要过滤
	if(config.url.indexOf('34d711b66761bb30efd5e9e87cc7016f') == -1) {
		config.headers.appCode = "SDZY"
		const token = localStorage.getItem('token')
    	token && (config.headers.token = token);
	}
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});


//减少401状态码多次弹出的情况
let isPast = false
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    if(!isPast) {
        if(response.config.url.indexOf('34d711b66761bb30efd5e9e87cc7016f') != -1 || response.config.url.indexOf('app/kkOrder/buy') != -1) {
            return response;
        }else {
            if(response.data.code == 7) {
                statusError(response.data.code)
                return 
			}
			if(response.data.code == 26) {
				Dialog.alert({
					title: '提示',
					message: response.data.msg,
				}).then(() => {
					router.push({ name: 'kefu'})
				})
				return 
			}
			if(response.data.code != '1' && response.data.code != 7 && response.data.code != 20){
				Notify({ type: 'danger', message: response.data.msg })
				Promise.reject(new Error(response.data.msg || 'Error'));
				return
			} 
            return response;
        }
    }
}, function (error) {
    // 对响应错误做点什么
	console.log('----------------------');
	console.log(error);
	return 
});

export default  instance



// WEBPACK FOOTER //
// ./src/api/api.js